import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class Note extends BasicDomain {
    static DEFAULTS = {
        observation: null,
        type: null,
        date: null,
        text: ''
    }

    static VALIDATION_SCHEMA = yup.object({
        observation: yup.object().required('Observation is required'),
        type: yup.object().required('Note type is required'),
        date: yup.date().required('Date is required'),
        text: yup.string().required('Text is required')
    }).required();

    constructor(props) {
        super('Note', props, Note.DEFAULTS);
    }


    inspect = () => {
        return Note.VALIDATION_SCHEMA.validate(this, { abortEarly: false });
    }
}

if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('Note', Note);
}